import { render, staticRenderFns } from "./SystemBaseMenu.vue?vue&type=template&id=d6f7f480&scoped=true"
import script from "./SystemBaseMenu.vue?vue&type=script&lang=js"
export * from "./SystemBaseMenu.vue?vue&type=script&lang=js"
import style0 from "./SystemBaseMenu.vue?vue&type=style&index=0&id=d6f7f480&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6f7f480",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d6f7f480')) {
      api.createRecord('d6f7f480', component.options)
    } else {
      api.reload('d6f7f480', component.options)
    }
    module.hot.accept("./SystemBaseMenu.vue?vue&type=template&id=d6f7f480&scoped=true", function () {
      api.rerender('d6f7f480', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/system/components/System/SystemBaseMenu.vue"
export default component.exports